import React from 'react';

const Security = () => {
  const securityFeatures = [
    {
      title: "Encrypted Data Storage",
      description: "All your medical and personal information is encrypted using industry-standard protocols, ensuring your data remains secure at rest and in transit."
    },
    {
      title: "Controlled Access",
      description: "Your information is only accessible through your unique QR code or personal key, which you control. Emergency access is strictly monitored and logged."
    },
    {
      title: "HIPAA Compliance",
      description: "Our platform is designed with healthcare privacy regulations in mind, implementing strict protocols to protect your sensitive medical information."
    },
    {
      title: "Regular Security Audits",
      description: "We conduct regular security assessments and updates to maintain the highest level of protection for your data."
    }
  ];

  return (
    <div className="min-h-screen bg-linear-to-b from-gray-900 to-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Your Security Is Our Priority
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            At olaid, we understand the sensitive nature of medical information. That's why we've implemented 
            robust security measures to ensure your data is protected at all times.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          {securityFeatures.map((feature, index) => (
            <div key={index} className="bg-secondary-dark rounded-lg p-8">
              <div className="flex items-center mb-4">
                <svg className="w-8 h-8 text-primary mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                </svg>
                <h3 className="text-2xl font-semibold text-white">{feature.title}</h3>
              </div>
              <p className="text-gray-300">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="bg-primary/10 rounded-lg p-8 border border-primary/20 max-w-3xl mx-auto">
          <h3 className="text-2xl font-semibold text-primary-light mb-4">Our Security Commitment</h3>
          <div className="text-gray-300 space-y-4">
            <p>
              We employ multiple layers of security to protect your information:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>End-to-end encryption for all data transmission</li>
              <li>Secure, encrypted database storage</li>
              <li>Regular security updates and maintenance</li>
              <li>Strict access controls and authentication</li>
              <li>Comprehensive audit logging</li>
            </ul>
            <p className="mt-6">
              Your trust is important to us. If you have any questions about our security measures or data protection practices, 
              please don't hesitate to contact our support team.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Security;
